import { render, staticRenderFns } from "./PrizeListEditor.vue?vue&type=template&id=7a51c35a"
import script from "./PrizeListEditor.vue?vue&type=script&lang=js"
export * from "./PrizeListEditor.vue?vue&type=script&lang=js"
import style0 from "./PrizeListEditor.vue?vue&type=style&index=0&id=7a51c35a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports